export default {
  // Không từ chối duyệt được do hồ sơ đã được Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
  // Không từ chối duyệt được do hồ sơ đã được Kế toán trưởng từ chối duyệt
  CompanyChiefAccountantReject: -1,
  // Không từ chối duyệt được do hồ sơ Chưa gửi Thủ trưởng duyệt
  FileNotSent: 1,
  // Không từ chối được do hồ sơ đã được gửi cho Thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Không từ chối được do hồ sơ đã được Thủ trưởng duyệt
  CompanyDirectorApproved: 3,
  // Không từ chối được do hồ sơ đã được gửi cho ủy quyền KTT duyệt
  DelegateReject: 99
};
